export type ValueSupplier<T> = (key: string) => T;

export class Cache<T> {
  private valueFn: ValueSupplier<T>;
  private cache: Record<string, T> = {};

  /**
   * Creates a new Cache.
   *
   * @param valueFn the value supplier function
   * @constructor
   */
  constructor(valueFn: ValueSupplier<T>) {
    this.valueFn = valueFn;
    return this.clear();
  }

  /**
   * Clears any cached data.
   * @return the cache for method chaining
   */
  clear(): this {
    this.cache = {};
    return this;
  }

  /**
   * Evaluates the Caches's value supplier for the given key and caches the result.
   * @param key the key
   * @return the data for the key
   */
  store(key: string): T {
    const value = this.valueFn(key);
    this.cache[key] = value;
    return value;
  }

  /**
   * Returns the data for the given key using the value supplier if needed.
   *
   * @param key the key
   * @return the data for the key
   */
  get(key: string): T {
    return this.cache[key] || this.store(key);
  }
}
